import { mapActions, mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(["getBusquedasAplicadas"])
    },
    methods: {
        ...mapActions(["setBusqueda"]),
        guardarBusquedaTags(busqueda, tipo) {
            let filtroNuevo = {
                tipo: tipo,
                filtro: busqueda.valor,
                texto: busqueda.texto,
                eliminable: true
            };
            let filtrosPrevios = [...this.getBusquedasAplicadas];
            let filtroRepetido = filtrosPrevios.findIndex(
                f => f.tipo === filtroNuevo.tipo
            );
            if (filtroRepetido !== -1) {
                filtrosPrevios.splice(filtroRepetido, 1);
            }
            if (filtroNuevo.filtro !== null) {
                filtrosPrevios.push(filtroNuevo);
            }
            this.setBusqueda(filtrosPrevios);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/tags.js